module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel-suns_spot_01-0947ee1cb34a83ea109af4e267537d40.jpg";